/**
 * 品牌规格 + 订单 specification 兼容
 * 下拉仅品牌关联规格；旧单 specification 单独补入选项回显
 */

function isJsonString(str) {
	if (typeof str !== 'string') return false;
	const t = str.trim();
	if (!t) return false;
	if (t[0] !== '{' && t[0] !== '[') return false;
	try {
		JSON.parse(t);
		return true;
	} catch (e) {
		return false;
	}
}

export function parseMlFromName(name) {
	if (name == null || name === '') return null;
	const s = String(name).trim();
	if (!s) return null;
	const m = s.match(/(\d+(?:\.\d+)?)\s*ml/i);
	if (!m) return null;
	const n = Number(m[1]);
	return Number.isFinite(n) && n > 0 ? n : null;
}

export function parseTypeCapacityRaw(raw) {
	if (!raw) return [];
	let arr = [];
	try {
		if (typeof raw === 'string') {
			arr = isJsonString(raw) ? JSON.parse(raw) : [];
		} else if (Array.isArray(raw)) {
			arr = raw;
		}
	} catch (e) {
		arr = [];
	}
	if (!Array.isArray(arr)) return [];
	return arr.filter((v) => v && (v.ml != null && v.ml !== '' || v.name));
}

function normalizeMl(ml) {
	if (ml == null || ml === '') return null;
	const n = Number(String(ml).trim());
	return Number.isFinite(n) && n > 0 ? n : null;
}

function capacityDisplayName(item) {
	if (!item) return '';
	if (item.name) return String(item.name);
	const ml = normalizeMl(item.ml);
	if (ml != null) {
		const label = Number.isInteger(ml) ? String(ml) : String(item.ml).trim();
		return '容量' + label + 'ml';
	}
	return '';
}

function itemKey(item) {
	if (!item) return '';
	if (item.specOptionId != null) return 'id:' + item.specOptionId;
	const ml = normalizeMl(item.ml);
	if (ml != null) return 'ml:' + ml;
	const name = (item.name || '').trim();
	return name ? 'name:' + name.toLowerCase() : '';
}

export function brandSpecOptionToCapacityItem(option) {
	if (!option) return null;
	const name = String(option.name || option.specOptionName || '').trim();
	if (!name) return null;
	const ml = normalizeMl(option.ml) || parseMlFromName(name);
	const id = option.id != null ? option.id : option.specOptionId;
	return {
		name: capacityDisplayName({ name, ml }),
		ml: ml != null ? ml : undefined,
		specOptionId: id != null ? Number(id) : undefined,
		price: option.price
	};
}

export function typeCapacityItemToOption(item) {
	if (!item) return null;
	const ml = normalizeMl(item.ml);
	const name = capacityDisplayName({
		name: item.name,
		ml: ml != null ? ml : item.ml
	});
	if (!name && ml == null) return null;
	return {
		name,
		ml: ml != null ? ml : undefined,
		price: item.price,
		specOptionId: item.specOptionId
	};
}

export function buildBrandSpecOptions(brandSpecList) {
	const map = new Map();
	(Array.isArray(brandSpecList) ? brandSpecList : []).forEach((row) => {
		const item = brandSpecOptionToCapacityItem(row);
		if (!item) return;
		const key = itemKey(item);
		if (!key || map.has(key)) return;
		map.set(key, item);
	});
	return Array.from(map.values());
}

/** @deprecated typeCapacityRaw 已忽略 */
export function buildCapacityOptions(brandSpecList, _typeCapacityRaw) {
	return buildBrandSpecOptions(brandSpecList);
}

export function ensureSavedSpecificationInOptions(options, specRaw) {
	const saved = specificationToCapacityItem(specRaw);
	if (!saved) return Array.isArray(options) ? options : [];
	const list = Array.isArray(options) ? [...options] : [];
	const savedKey = itemKey(saved);
	if (!savedKey) return list;
	if (list.some((item) => itemKey(item) === savedKey)) return list;
	return [...list, saved];
}

export function getCapacitySelectValue(item) {
	if (!item) return '';
	const ml = normalizeMl(item.ml);
	if (ml != null) return String(ml);
	return (item.name || '').trim();
}

export function findCapacityItemBySelectValue(arr, value) {
	if (value == null || value === '') return null;
	const val = String(value);
	return (arr || []).find((item) => getCapacitySelectValue(item) === val) || null;
}

export function specificationToCapacityItem(specRaw) {
	if (!specRaw) return null;
	let spec = specRaw;
	if (typeof specRaw === 'string') {
		if (!isJsonString(specRaw)) return null;
		try {
			spec = JSON.parse(specRaw);
		} catch (e) {
			return null;
		}
	}
	if (!spec || typeof spec !== 'object') return null;
	const ml = normalizeMl(spec.ml);
	const name = spec.name ? String(spec.name).trim() : '';
	const parsedMl = ml != null ? ml : parseMlFromName(name);
	return {
		name: name || capacityDisplayName({ ml: parsedMl }),
		ml: parsedMl != null ? parsedMl : undefined,
		price: spec.price,
		specOptionId: spec.specOptionId
	};
}

export function capacityItemToSpecification(item) {
	if (!item) return null;
	const ml = normalizeMl(item.ml);
	const name = (item.name || '').trim() || (ml != null ? capacityDisplayName({ ml }) : '');
	const out = {};
	if (name) out.name = name;
	if (ml != null) out.ml = ml;
	if (item.price != null && item.price !== '') out.price = item.price;
	if (item.specOptionId != null) out.specOptionId = item.specOptionId;
	return Object.keys(out).length ? out : null;
}

export function formatSpecificationDisplay(specRaw) {
	const item = specificationToCapacityItem(specRaw);
	if (!item) return '';
	if (item.name) return item.name;
	const ml = normalizeMl(item.ml);
	return ml != null ? ml + 'ml' : '';
}

export function resolveOrderBrandId(order, typeRow) {
	if (!order) return null;
	if (order.brandId != null && order.brandId !== '') return Number(order.brandId);
	if (order.brand && order.brand.id != null) return Number(order.brand.id);
	if (typeRow && typeRow.brandId != null) return Number(typeRow.brandId);
	if (order.type && order.type.brandId != null) return Number(order.type.brandId);
	return null;
}

/** 拉品牌规格；savedSpecification 仅用于旧单回显补项 */
export function fetchOrderCapacityOptions(https, enabledOptionsUrl, brandId, savedSpecification) {
	const bid = brandId != null && brandId !== '' ? Number(brandId) : null;
	const finish = (brandSpecs) => {
		let options = buildBrandSpecOptions(brandSpecs);
		return ensureSavedSpecificationInOptions(options, savedSpecification);
	};
	if (!bid || Number.isNaN(bid)) {
		return Promise.resolve(finish([]));
	}
	return https(enabledOptionsUrl + bid, {}, 'GET')
		.then((res) => {
			const list = res && res.data && res.data.code === 200 && Array.isArray(res.data.data)
				? res.data.data
				: [];
			return finish(list);
		})
		.catch(() => finish([]));
}



// WEBPACK FOOTER //
// ./src/util/specCapacityCompat.js